document.addEventListener('DOMContentLoaded', () => {
  const lacesVariantsArray = document.querySelectorAll('.product__variantsSwatchesList p');
  const swatchVariant = document.querySelector('.product__variantsSwatchesHeader span');

  function toggleVariant(event) {
    const currentVariant = event.currentTarget;
    const currentWrapper = currentVariant.closest('.product__variantsSwatchesList');
    const activeVariant = currentWrapper.querySelector('.product__variantsSwatchesListItems--active');
    const bundleSizeData = document.querySelector('.product__variantsSwatchesHeader[data-bundle-size]');

    if (currentVariant.classList.contains('.product__variantsSwatchesListItems--active')) {
      return
    } else {
      const variantLabel = document.querySelector(`.product__swatchesItemLabel label[data-size="${currentVariant.dataset.variant}"]`);

      activeVariant.classList.remove('product__variantsSwatchesListItems--active');
      currentVariant.classList.add('product__variantsSwatchesListItems--active');

      variantLabel.click();

      if (swatchVariant) {
        toggleSwatchHeader();
      }

      if (bundleSizeData) {
        const pathArray = window.location.pathname.split('/');
        const activeTab = document.querySelector('.product__variantsSwatchesList--active .product__variantsSwatchesListItems--active');
        const activeTabSize = document.querySelector('.product__lacesTabsLinksItem--active');

        localStorage.setItem('lastVisitedPath', `${pathArray[pathArray.length - 1]};${activeTab.dataset.variant};${activeTab.dataset.size};${activeTabSize.dataset.type}`);
      }
    }
  }

  function toggleSwatchHeader() {
    const activeVariant =
      document.querySelector('.product__variantsSwatchesList--active .product__variantsSwatchesListItems--active').dataset.variant
      || document.querySelector('.selected-swatch').dataset.option;

    swatchVariant.innerText = activeVariant;
  }

  function initAutoSelect() {
    const bundleSizeData = document.querySelector('.product__variantsSwatchesHeader[data-bundle-size]');
    const dataPath = localStorage.getItem('lastVisitedPath');
    const minicartCount = document.querySelector('.minicart-count');
    const pathArray = dataPath?.split(';');

    if (
      dataPath && +minicartCount.innerText > 1
      && window.location.pathname.includes(pathArray[0])
    ) {
      const activeType = document.querySelector(`.product__lacesTabsLinksItem[data-type="${pathArray[3]}"]`);

      activeType.click();

      const activeProductSwatch = document.querySelector('.product__variantsSwatchesList--active');
      const activeSwatch = activeProductSwatch.querySelector(`p[data-variant="${pathArray[1]}"]`);

      activeSwatch.click();
    } else if (bundleSizeData) {
      const currentTab = document.querySelector(`.product__lacesTabsLinksItem[data-type="${bundleSizeData.dataset.type}"]`);

      if (currentTab)currentTab.click();

      const activeProductSwatch = document.querySelector('.product__variantsSwatchesList--active');
      const currentSwatch = activeProductSwatch.querySelector(`p[data-variant="${bundleSizeData.dataset.bundleSize}"]`);
      const currentProductSize = activeProductSwatch.querySelector(`p[data-size="${bundleSizeData.dataset.productSize}"]`);


      if (currentProductSize) {
        currentProductSize.click();
      } else if (currentSwatch) {
        currentSwatch.click();
      }
    } else {
      if (document.referrer.includes('men') && !document.referrer.includes('women')) {
        const mensBundle = document.querySelector('[data-type="mens"]');

        mensBundle?.click();
      }
    }
  }

  lacesVariantsArray.forEach(variant => {
    variant.addEventListener('click', (event) => {
      toggleVariant(event);
    });
  });

  if (swatchVariant) {
    toggleSwatchHeader();
    initAutoSelect();
  }
});
